import React, { Component, MouseEvent } from 'react';
import styled from '@emotion/styled';
import { PrimaryButton } from '../../buttons';

const TextInput = styled.input`
  padding-left: 10px;
  height: 45px;
  width: 80%;
  border: 2px solid #bdcad2;

  &:focus {
    background-color: #f5fbff;
  }

  &:invalid {
    border: 2px solid red;
  }
`;

const InputForm = styled.form`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

interface Props {
  addItemClick: (selected: string) => void;
  projectId: number;
}

interface State {
  email: string;
  disabled: boolean;
}

export class ShareStandardInputField extends Component<Props, State> {
  state = {
    email: '',
    disabled: true,
  };

  addEmailClick: React.EventHandler<MouseEvent> = e => {
    e.preventDefault();
    const emailValue = (this.refs.emailInput as HTMLInputElement).value;
    if (emailValue) {
      this.props.addItemClick(emailValue);
      (this.refs.emailInput as HTMLInputElement).value = '';
    }
  };

  validateEmail = () => {
    const formValidity = (this.refs.inputForm as HTMLFormElement).checkValidity();
    const emailValue = (this.refs.emailInput as HTMLInputElement).value;

    this.setState({ ...this.state, disabled: !formValidity || emailValue === '' });
  };

  render() {
    return (
      <InputForm ref="inputForm">
        <TextInput
          ref="emailInput"
          type="email"
          placeholder="Enter email address"
          onKeyUp={this.validateEmail}
        />
        <PrimaryButton
          disabled={this.state.disabled}
          clickFn={e => {
            return e && this.addEmailClick(e);
          }}
        >
          Add
        </PrimaryButton>
      </InputForm>
    );
  }
}

export default ShareStandardInputField;
